import React from 'react';

const NoProducts = () => {
  return (
    <div className="no-product__body">
      <h3 className="no-product__body-title">Мы не нашли тот товар, что вы искали.</h3>
      <p className="no-product__body-text">Мы очень старались, правда.</p>
    </div>
  );
};

export default NoProducts;
